import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import * as actions from "../../../../../store/actions";
import { getUserData } from "../../../../../utils/localStorage";

import SpinnerBorder from "../../../../../components/uiElements/loadingSpinner/SpinnerBorder";

const Prescriptions = ({ getSSOURL, currentAppointment, patient}) => {
  const [ssoUrl, setSSOUrl] = useState();
  const [iframeLoading, setIFrameLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    getSSOURL(
      getUserData()?.dosespot_id,
      data => {
        setIFrameLoading(true);
        setSSOUrl(data?.url);
      },
      location.pathname.includes("start-call")? 
      currentAppointment?.patient_dosespot_id : 
      patient?.dosespot_id
    );
    //eslint-disable-next-line
  }, []);

  return (
    <div className="calladdnotes px-2">
      {iframeLoading ? (
        <SpinnerBorder
          isCenter
          size="lg"
          style={{
            color: "var(--secondary-color)",
          }}
        />
      ) : null}
      <div
        className="embed-responsive embed-responsive-16by9"
        style={{
          height: "100vh",
        }}
      >
        <iframe
          className="embed-responsive-item"
          src={ssoUrl}
          title="SSO Login"
          onLoad={() => setIFrameLoading(false)}
        ></iframe>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard, onboarding, api }) => ({
  currentAppointment: dashboard?.ongoingAppointment?.currentAppointment,
  patient: dashboard?.patients?.patient,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  getPatientVitals: () => dispatch(actions.getPatientVitals()),
  getSSOURL: (userId, cb, patientId) =>
    dispatch(actions.getSSOURL(userId, cb, patientId)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Prescriptions);
